import React from "react";

const NotFound = () => {
  return <div>this is not found page</div>;
};

export default NotFound;
